import { defineMessages } from 'react-intl';
import { DashboardRoles } from '@algoan/dashboard/model';

export const dashboardRoleMessages = defineMessages({
  [DashboardRoles.ADMIN]: {
    id: 'dashboard_role.admin',
    defaultMessage: 'Admin',
    description: 'Dashboard role Admin',
  },
  [DashboardRoles.MANAGER]: {
    id: 'dashboard_role.manager',
    defaultMessage: 'Manager',
    description: 'Dashboard role Manager',
  },
  [DashboardRoles.CONSULTANT]: {
    id: 'dashboard_role.consultant',
    defaultMessage: 'Consultant',
    description: 'Dashboard role Consultant',
  },
  [DashboardRoles.INITIATOR]: {
    id: 'dashboard_role.initiator',
    defaultMessage: 'Initiator',
    description: 'Dashboard role Initiator',
  },
  [DashboardRoles.NONE]: {
    id: 'dashboard_role.none',
    defaultMessage: 'None',
    description: 'Dashboard role None',
  },
});
